import e from "react";
import { componentName as t } from "../../../utils/bem/index.js";
import { GlobalListener as n } from "../../offscreen/GlobalListener/GlobalListener.js";
import { FlatList as r } from "./SelectableListFlat.js";
function o(o) {
  var l = o.groups,
    a = o.template,
    i = o.children;
  if (!l || 0 === l.length) return null;
  var m = t("selectable-grouped-list", o.className);
  return e.createElement("ul", {
    className: m,
    onScroll: o.onScroll
  }, o.enableKeyboardNavigation && e.createElement(n, {
    types: "keydown",
    onEnter: o.onEnter,
    onArrowDown: o.onNext,
    onArrowUp: o.onPrevious
  }), i, l.map(function (t, n) {
    return e.createElement(e.Fragment, {
      key: n
    }, t.name && e.createElement("li", {
      className: "selectable-grouped-list__group-name"
    }, t.name), e.createElement(r, {
      template: a,
      onClick: function onClick(e, t, r) {
        return o.onClick(e, [n, t], r);
      },
      isSelectedFn: function isSelectedFn(e, t) {
        return o.isSelectedFn(e, [n, t]);
      },
      items: t.items
    }));
  }));
}
export { o as GroupedList };